import { Product } from './product';
import { User } from './user';

export class PrivateProfile {
    id: string;
    displayName: string;
    email: string;
    rol: string;
    fullName: string;
    document: string;
    documentType: string;
    termsAndConditions: boolean;
    emailOffers: boolean;
    mobilePhoneNumber: string;
    sponsorId: string;
    sponsorDisplayName: string;
    sponsorEmail: string;
    address: string;
    country: {
        code: string
        name: string
    };
    region: {
        name: string
    };

    department: {
        code: string
        name: string
    };
    city: {
        code: string,
        name: string
    };
    referredUsers: User[];

    shoppingCart: Product[];

    constructor() {
        this.displayName = '';
        this.email = '';
        this.rol = '';
        this.fullName = '';
        this.document = '';
        this.documentType = '';
        this.termsAndConditions = true;
        this.emailOffers = false;
        this.mobilePhoneNumber = '';
        this.sponsorId = '';
        this.sponsorDisplayName = '';
        this.sponsorEmail = '';
        this.address = '';
        this.country = {
            code: '57',
            name: 'Colombia'
        };
        this.region = {
             name: ''
        };
        this.department = {
            code: '',
            name: ''
        };
        this.city = {
            code: '',
            name: ''
        };
        this.referredUsers = new Array<User>();
        this.shoppingCart = new Array<Product>();
    }
}
